import { AppLinkTree } from "@megarax/links";

import { MegaraxNavSection } from "./MegaraxNavSection";
import { shouldKeepNavSectionsExpanded } from "./navHelpers";

type Props = {
  linkTree: AppLinkTree[];
  onNavigate?: () => void;
  keepSectionsExpanded?: boolean;
};

export const NavLinkTreeSections: React.FC<Props> = ({ linkTree, onNavigate, keepSectionsExpanded }) => {
  const areSectionsExpanded = keepSectionsExpanded ?? shouldKeepNavSectionsExpanded(linkTree);

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
      {linkTree.map((appTree) => (
        <MegaraxNavSection
          key={appTree.app}
          appTree={appTree}
          onNavigate={onNavigate}
          keepSectionsExpanded={areSectionsExpanded}
        />
      ))}
    </div>
  );
};
